module.exports = __webpack_public_path__ + "img/hu.2e0e3e50.svg";